import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { CardPrintComponent } from '@app/cards/card-print/card-print.component';
import { CookieConsentService } from './@shared/services/cookieConsent.service';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: '',
      loadChildren: () =>
        import('./home/home.module').then((m) => m.HomeModule),
    },
  ]),
  Shell.childRoutes([
    {
      path: 'about',
      loadChildren: () =>
        import('./about/about.module').then((m) => m.AboutModule),
    },
  ]),
  Shell.childRoutes([
    {
      path: 'carte',
      loadChildren: () => import('./map/map.module').then((m) => m.MapModule),
    },
  ]),
  Shell.childRoutes([
    {
      path: 'fiche',
      loadChildren: () =>
        import('./cards/card.module').then((m) => m.CardModule),
    },
  ]),
  Shell.childRoutes([
    {
      path: 'inspiration',
      loadChildren: () =>
        import('./inspiration/inspiration.module').then(
          (m) => m.InspirationModule
        ),
    },
  ]),
  Shell.childRoutes([
    {
      path: 'panorama',
      loadChildren: () =>
        import('./panorama/panorama.module').then((m) => m.PanoramaModule),
    },
  ]),
  {
    path: 'print/:id',
    component: CardPrintComponent,
  },
  // Fallback when no prior route is matched
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
  providers: [CookieConsentService],
})
export class AppRoutingModule {}
